import React from "react";
import * as Styles from "../styles/Basket";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../../redux/store";
import Icon from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { BnbLabel, getBnbLabel } from "../../../../../utils/labels";
import { showModal } from "../../../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_CONTENT } from "../../../../../../../../common-deprecated/utils/modalConstants";
import { Separator } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Separator";
import { showExternalPriceTax } from "../../../../../utils/settings/bnbSettingUtils";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

const BasketHeader = (): JSX.Element => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const car = useBnbSelector((state) => state.car);
    const externalPrice = useBnbSelector((state) => state.externalPrice);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);

    return (
        <>
            <Styles.BasketTitle>{car.grade.webtitleSectionName}</Styles.BasketTitle>
            <Styles.BasketSubTitle>{car.body.webtitleSectionName}</Styles.BasketSubTitle>
            {car.grade.webtitleSectionName.length || car.body.webtitleSectionName.length ? <Separator /> : null}
            <Styles.CarDetails>
                <li>{car.motorization.engine.name}</li>
                <li>
                    {car.motorization.transmission.name} ({car.motorization.wheeldrive.name})
                </li>
                {externalPrice.co2Specs.value && !showExternalPriceTax(bnbSettings) && (
                    <>
                        <li>
                            <BnbLabel
                                label="co2Value"
                                params={{ value: `${externalPrice.co2Specs.value} ${externalPrice.co2Specs.unit}` }}
                            />
                            &nbsp;
                            <a
                                href="src/new-cars/original/buildandbuy/components/lexus/common/basket/content#"
                                className="or-link or-has-icon"
                                onClick={(event) => {
                                    event.preventDefault();
                                    dispatch(
                                        showModal({
                                            type: MODAL_CONTENT,
                                            content: getBnbLabel({ commonSettings, bnbSettings }, "co2Disclaimer"),
                                            useHTML: true,
                                        }),
                                    );
                                }}
                            >
                                <Icon variant="info" />
                            </a>
                        </li>
                    </>
                )}
            </Styles.CarDetails>
        </>
    );
};

export default BasketHeader;
